/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlDomains
 */
export interface ControlDomains {
    /**
     * 
     * @type {Array<string>}
     * @memberof ControlDomains
     */
    domains: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ControlDomains
     */
    ip: string;
    /**
     * 
     * @type {number}
     * @memberof ControlDomains
     */
    total: number;
}

/**
 * Check if a given object implements the ControlDomains interface.
 */
export function instanceOfControlDomains(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "domains" in value;
    isInstance = isInstance && "ip" in value;
    isInstance = isInstance && "total" in value;

    return isInstance;
}

export function ControlDomainsFromJSON(json: any): ControlDomains {
    return ControlDomainsFromJSONTyped(json, false);
}

export function ControlDomainsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlDomains {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'domains': json['domains'],
        'ip': json['ip'],
        'total': json['total'],
    };
}

export function ControlDomainsToJSON(value?: ControlDomains | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'domains': value.domains,
        'ip': value.ip,
        'total': value.total,
    };
}

